import { Component, OnInit, ElementRef, OnDestroy, AfterContentInit, AfterViewInit, AfterContentChecked } from '@angular/core';
import { Location } from '@angular/common';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { UserStateService } from 'src/app/core/services/user/user-state.service';
import { User, UserRole } from '../models/users/user';
import { ActivatedRoute, Router } from '@angular/router';
import { CaseSearchParams } from '../models/cases/caseSearchParams';
import { FileFilterService } from 'src/app/core/services/files-filter.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { NotificationService } from 'src/app/core/services/notifications.service';
import { Notification } from '../models/notification';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Observable, of, OperatorFunction, Subject } from 'rxjs';
import { CaseSearchResultsLite } from '../models/cases/caseSearchResults';
import { CaseLite } from '../models/cases/caseLite';
import { SearchParams } from '../models/searchParams';

declare interface RouteInfo {
  path: string;
  title: string;
  auth: boolean
}


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  navItems: any[] = [];
  location: Location;
  mobileMenuVisible = 0;
  conversations = [];
  public logo = null;
  public user: User = null;
  public isCollapsed = true;
  public notifications = [];
  userRole = UserRole;
  AMIN_NAV_ITEMS: RouteInfo[];
  public params: CaseSearchParams = new CaseSearchParams();
  destroyed$ = new Subject();

  isExpense = false;

  public unreadCount = 0;

  model: any;
  searching = false;
  searchFailed = false;


  constructor(
    location: Location,
    private authService: AuthService,
    private userState: UserStateService,
    private router: Router,
    private fileFilters: FileFilterService,
    private spinner: NgxSpinnerService,
    private fileApiService: FilesApiService,
    private notifyService: NotificationService,
    private toastr: ToastrService
  ) {
    this.location = location;
    this.logo = this.userState.getItem('providerLogo');
    this.user = this.authService.user;

  }

  ngOnInit() {
    console.log("on init hit");

    this.AMIN_NAV_ITEMS = [
      {
        path: '/dashboard',
        title: 'Dashboard',
        auth: true
      },
      {
        path: '/clients',
        title: 'Clients',
        auth: this.user.role === this.userRole.ADMIN || this.user.role === this.userRole.DATA_ENTRY
      },
      {
        path: '/files',
        title: 'Files',
        auth: true

      },
      {
        path: '/rolls',
        title: 'Rolls',
        auth: this.user.role === this.userRole.ADMIN || this.user.role === this.userRole.DATA_ENTRY

      },
      {
        path: '/financials',
        title: 'Financials',
        auth: this.user.role === this.userRole.ADMIN || this.user.role === this.userRole.ACCOUNTING
      },
      {
        path: '/timesheet',
        title: 'Timesheet',
        auth: this.user.role === this.userRole.ACCOUNTING
      },
      // {
      //   path: '/library',
      //   title: 'Library',
      //   auth: true
      // },
      {
        path: '/files/reports',
        title: 'Reports',
        auth: this.user.role === this.userRole.ADMIN
      },
    ];
    this.navItems = this.AMIN_NAV_ITEMS.filter(menuItem => menuItem);

    this.loadNotificationsInit();
    this.listenToNotifications();
  }

  loadNotificationsInit() {
    this.notifyService.notifications().subscribe(
      r => {
        this.notifications = r.results;
        this.unreadCount = this.unreadCount;
      }
    )
  }

  listenToNotifications() {
    this.notifyService.listen().pipe(
      takeUntil(this.destroyed$)
    ).subscribe(r => {
      if (r) {
        this.unreadCount = r.unreadCount;
        this.notifications.push(r.unread);
        this.toastr.info(`<span class="tim-icons icon-bell-55" [data-notify]="icon"></span> ${r.unread.message}`, '', {
          disableTimeOut: true,
          closeButton: true,
          enableHtml: true,
          toastClass: 'alert alert-info alert-with-icon',
          positionClass: 'toast-top-right'
        }).onTap
          .pipe(take(1))
          .subscribe(() => this.handleNotificationClick(r.unread));
      }
    });
  }

  handleNotificationClick(notification: Notification) {
    if (!notification.unread) {
      this.router.navigate([notification.redirectUrl]);
      return;
    }
    this.spinner.show();
    this.notifyService.markNotificationAsRead(notification.id).subscribe(
      r => {
        this.spinner.hide()
        notification.unread = false;
        this.router.navigate([notification.redirectUrl]);
      }
    )
  }

  search: OperatorFunction<string, readonly CaseLite[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(term => {
        this.searching = true;
        this.params.search = term;
      }),
      switchMap(term => term === '' ? of(null) :
        this.fileApiService.getFilesTiny(this.params).pipe(
          map((response: CaseSearchResultsLite) => response.results),
          tap(() => this.searchFailed = false)
        )
      ),
      tap(() => this.searching = false)
    )

  formatter = (x: CaseLite) => x.seqNumber;

  collapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  logout() {
    this.authService.logout();
  }
  clickTimesheet() {
    if (this.user.role === this.userRole.ADMIN) {
      this.router.navigate(['/timesheet']);
    }
  }

  onSearch(e: KeyboardEvent) {
    if (e.keyCode === 13) {
      this.loadFiles();
    }
  }

  loadFiles() {
    this.spinner.show();
    this.fileApiService.getFilesLite(this.params).subscribe(
      c => {
        this.router.navigate(['/files/' + c.results[0].id]);
        this.spinner.hide();
      }
    )
  }

  handleFile(e) {
    this.router.navigate(['/files/' + e.item.id]);
  }
}
